import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import modules from "./modules";
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";


export default new Vuex.Store({
  strict: debug,
  getters,
  modules,
});



// WEBPACK FOOTER //
// ./src/store/index.js